
const NotFound = () => {
  return (
    <h2 style={{margin: "1rem"}}>Page Not Found...</h2>
  )
}

export default NotFound